/*
 * Dicas dos botões só de ícone. Todo botão de ícone deve ter um `title` (os
 * controles do post, os ícones do cabeçalho, o ✕ dos modais), para o
 * navegador mostrar a dica ao parar o mouse. No Flarum esses botões só têm
 * `aria-label`; quando não estão dentro de um `<Tooltip>` do core, o rótulo
 * vira também o `title`.
 */
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
const pending = new Set();
let scheduled = false;
function sync(element) {
  if (!element.isConnected) return;

  // O <Tooltip> do core já mostra a dica (e guarda o texto no jQuery).
  const $ = window.$;
  if ($ && $(element).data('bs.tooltip')) return;
  const own = element.dataset.canelaTitle;
  const current = element.getAttribute('title');

  // Um título próprio do componente manda.
  if (current && current !== own) return;
  const label = element.getAttribute('aria-label')?.trim();
  const iconOnly = !element.textContent?.trim();
  if (label && iconOnly) {
    if (current !== label) element.setAttribute('title', label);
    element.dataset.canelaTitle = label;
  } else if (own) {
    element.removeAttribute('title');
    delete element.dataset.canelaTitle;
  }
}
function flush() {
  scheduled = false;
  pending.forEach(sync);
  pending.clear();
}
export default function installTooltips() {
  // Espera o quadro: o <Tooltip> em volta do botão monta depois dele.
  extend(Button.prototype, ['oncreate', 'onupdate'], function () {
    const element = this.element;
    if (!element) return;
    pending.add(element);
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(flush);
    }
  });
}
flarum.reg.add('ramon-canela', 'forum/motion/tooltips', installTooltips);